import React from 'react';
import { Chip } from '@mui/material';

interface DraftChipProps {
  bgcolor?: string;
  opacity?: number;
  fontWeight?: number | string;
  letterSpacing?: string;
  boxShadow?: string;
  textShadow?: string;
  borderColor?: string;
  textColor?: string;
}

const DraftChip: React.FC<DraftChipProps> = ({ 
  bgcolor = 'background.paper', 
  opacity = 0.85,
  fontWeight = 'bold',
  letterSpacing = 'normal',
  boxShadow = 'none',
  textShadow = 'none',
  borderColor,
  textColor = '#fff'
}) => {
  return (
    <Chip
      label="DRAFT"
      size="small"
      variant={borderColor ? 'outlined' : 'filled'}
      sx={{
        bgcolor,
        color: textColor,
        fontWeight,
        fontSize: '0.75rem',
        opacity,
        boxShadow,
        ...(borderColor && { 
          border: `1px solid ${borderColor}`,
          bgcolor: bgcolor,
        }),
        '& .MuiChip-label': {
          color: textColor,
          fontWeight,
          letterSpacing,
          textShadow,
        },
      }}
    />
  );
};

export default DraftChip;
